<template>
	<div ref="tablePage" style="height: 100%">
		<!-- 面包屑导航 -->
		<div class="topNav">
			<div class="navFormWrapper">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>营销短信</el-breadcrumb-item>
				</el-breadcrumb>
				<el-form ref="queryForm" :model="searchForm" inline label-width="58px" style="margin-left: 3vh">
					<el-form-item style="margin-bottom: 0">
						<el-input v-model="searchForm.title" autocomplete="off" maxlength="30" placeholder="请输入名称"
							clearable @input="searchChange" size="small" />
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-select v-model="searchForm.xiaoqus" placeholder="请选择小区" clearable style="width: 100%"
							size="small" filterable @change="searchChange" @clear="searchClearInput">
							<el-option v-for="item in regionArr" :key="item.id" :label="item.xiaoqu_name"
								:value="item.xiaoqu_id" />
						</el-select>
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-select v-model="searchForm.status" placeholder="请选择短信状态" clearable style="width: 100%"
							size="small" filterable @change="searchChange" @clear="searchStatusClearInput">
							<el-option v-for="(item,index) in statusList" :key="item.id" :label="item.title"
								:value="item.id" />
						</el-select>
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-select v-model="searchForm.commonUse" placeholder="请选择适用小区" clearable style="width: 100%"
							size="small" filterable @change="searchChange" @clear="searchXiaoQuTypeClearInput">
							<el-option v-for="(item,index) in xqTypeList" :key="item.id" :label="item.title"
								:value="item.id" />
						</el-select>
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-button icon="el-icon-refresh-left" type="warning" @click="clearSearchInput"
							size="small">重置</el-button>
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-button type="success" icon="el-icon-plus" @click="handleNewAdd" size="mini">新增短信</el-button>
					</el-form-item>
				</el-form>
				<el-switch v-model="aiSwitch" active-value="1" active-color="#13ce66" active-text="开启电销"
					inactive-text="关闭电销" inactive-value="0" @change="changeAction"></el-switch>
			</div>
		</div>
		<el-table :data="tableList" style="width: 100%; margin-top: 2vh" border size="mini"
			:header-cell-style="{background: '#fff',height: '50px',color: '#909399',fontSize: '16px',fontFamily: 'Arial, sans-serif'}">
			<el-table-column prop="id" label="ID" align="center" width="80"></el-table-column>
			<el-table-column prop="title" label="名称" align="center"></el-table-column>
			<el-table-column prop="content" label="内容" align="center"></el-table-column>
			<el-table-column prop="xiaoqus" label="小区" align="center">
				<template slot-scope="scope">
					<div v-for="(xiaoqu_id,index) in scope.row.xiaoqus.split(',')" :key="index">
						{{findXiaoqu(xiaoqu_id)}}
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="fee_count" label="计费条数" align="center" width="90"></el-table-column>
			<el-table-column label="发送时间" align="center">
				<template slot-scope="scope">
					<div>{{(scope.row.send_day?scope.row.send_day:'')+' '+(scope.row.send_time?scope.row.send_time:'')}}
					</div>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="send_day" label="发送日期" align="center"></el-table-column>
			<el-table-column prop="send_time" label="发送时间" align="center"></el-table-column> -->
			<el-table-column label="创建/更新" align="center">
				<template slot-scope="scope">
					<div>创建:{{scope.row.create_time?scope.row.create_time:''}}</div>
					<div>更新：{{scope.row.update_time?scope.row.update_time:''}}</div>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="create_time" label="创建时间" align="center"></el-table-column>
			<el-table-column prop="update_time" label="更新时间" align="center"></el-table-column> -->
			<el-table-column prop="" label="状态" align="center" width="80">
				<template slot-scope="scope">
					<el-switch v-model="scope.row.status" :active-value="1" active-color="#13ce66" :inactive-value="0"
						@change="changeStatus(scope.row)"></el-switch>
				</template>
			</el-table-column>
			<el-table-column fixed="right" label="操作" align="center">
				<template slot-scope="scope">
					<el-button @click.native.prevent="handleClick(scope.row)" type="primary" size="small"
						icon="el-icon-edit">
						修改
					</el-button>
					<el-button @click.native.prevent="singleDel(scope.row, scope.row.id)" icon="el-icon-delete"
						type="danger" size="small">
						删除
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<pagination v-show="total > 0" :total="total" :page.sync="searchForm.page" :limit.sync="searchForm.pageSize"
			@pagination="initList" />
		<el-dialog :title="title" :visible.sync="addOrEditOpen" :close-on-click-modal="false" width="45%"
			class="dialogHeight2 global-dialog-position" :before-close="getout" :lock-scroll="false"
			:append-to-body="true" style="margin-top: -10vh">
			<el-form ref="form" :model="form" label-width="108px" :rules="rules">
				<el-row>
					<el-col :span="24">
						<el-form-item label="名称" prop="title">
							<el-input v-model="form.title" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="内容" prop="content">
							<el-input v-model="form.content" type="textarea" rows="5" autocomplete="off"
								placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="发送日期" prop="send_day">
							<el-date-picker v-model="form.send_day" format="yyyy年MM月dd日" value-format="yyyy-MM-dd"
								type="date" align="right" style="width: 100%" @input="changeDate">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="发送时间" prop="send_time">
							<el-time-picker v-model="form.send_time" format="HH:mm"
								value-format="HH:mm"></el-time-picker>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="计费条数" prop="fee_count">
							<!-- <el-input v-model="form.fee_count" autocomplete="off" placeholder="请输入" /> -->
							<el-input-number v-model="form.fee_count" :min="1" :max="10" label=""></el-input-number>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="选择小区" prop="xiaoqusArr">
							<el-select v-model="form.xiaoqusArr" style="width: 100%;" placeholder="请选择小区" clearable
								size="small" filterable multiple="" @change="xiaoquSelectChange" @clear="addClearInput">
								<el-option v-for="item in regionArr" :key="item.xiaoqu_id" :label="item.xiaoqu_name"
									:value="item.xiaoqu_id" />
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="通用型" prop="commonUse">
							<el-checkbox v-model="form.commonUse" :true-label="1" :false-label="0"></el-checkbox>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForms">确 定</el-button>
				<el-button @click="getout">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import tableCommon from "../../../mixins/table-common";
	import {
		getsmsTemplate,
		editsmsTemplate,
		addsmsTemplate,
		deletesmsTemplate,
		smsTemplateSwitch
	} from "../../api/smsTemplate";
	import {
		querySmsStatus,
		switchSmsStatus
	} from "../../api/aiCall";
	import {
		getcarList
	} from "../../api/garage";
	import {
		getCarList
	} from "../../api/parking";

	export default {
		mixins: [tableCommon],
		data() {
			return {
				// 请求地址api
				api: {
					list: getsmsTemplate,
					edit: editsmsTemplate,
					add: addsmsTemplate,
					del: deletesmsTemplate
				},
				// 规则验证
				rules: {
					title: [{
						required: true,
						message: "请输入名称",
						trigger: "blur"
					}],
					content: [{
						required: true,
						message: "请输入内容",
						trigger: "blur"
					}],
					xiaoqusArr: [{
						required: false,
						message: "请选择小区",
						trigger: "change"
					}],
					commonUse: [{
						required: false,
						message: "请选择是否通用",
						trigger: "change"
					}]
				},
				// 传参
				form: {},
				// 弹窗标题
				title: "新增",
				addOrEditOpen: false,
				statusList: [{
					id: 1,
					title: '开启'
				}, {
					id: 0,
					title: '关闭'
				}],
				xqTypeList: [{
					id: 1,
					title: '通用'
				}, {
					id: 0,
					title: '专用'
				}],
				// 查询参数
				searchForm: {
					page: 1,
					pageSize: 15,
					title: '',
					xiaoqus: '',
					status: '',
					commonUse: ''
				},
				tableData: [],
				regionArr: [],
				carparks: [],
				aiSwitch: '0'
			};
		},
		mounted() {
			const form = {
				select: 1,
			};
			getcarList(form).then((res) => {
				this.regionArr = res.data.records.filter((item, index, self) => {
					return self.findIndex((t) => t.xiaoqu_id === item.xiaoqu_id) === index;
				});
				this.regionArr.forEach((item, index) => item.xiaoqu_id = item.xiaoqu_id.toString());
				console.log(this.regionArr)
			});
			querySmsStatus({
				button_type: 'marketSmsButton'
			}).then((res) => {
				if (res.code == 200) {
					this.aiSwitch = res.data.value
				}
			});
		},
		methods: {
			changeAction() {
				switchSmsStatus({
					button_type: 'marketSmsButton'
				}).then((res) => {
					if (res.code == 200) {

					} else {
						this.aiSwitch = !this.aiSwitch;
					}
				});
			},
			xiaoquSelectChange(data) {
				this.$forceUpdate();
			},
			searchClearInput() {
				this.searchForm.xiaoqus = ''
				this.searchChange();
			},
			clearSearchInput() {
				this.searchForm.title = '';
				this.searchForm.xiaoqus = '';
				this.searchForm.status = '';
				this.searchForm.commonUse = '';
				this.searchChange();
			},
			searchStatusClearInput() {
				this.searchForm.status = '';
				this.searchChange();
			},
			searchXiaoQuTypeClearInput() {
				this.searchForm.commonUse = '';
				this.searchChange();
			},
			addClearInput() {
				this.form.xiaoqusArr = []
			},
			changeDate(e) {
				this.$forceUpdate();
			},
			findXiaoqu(xiaoqu_id) {
				let xiaoqu = this.regionArr.find(item => item.xiaoqu_id == xiaoqu_id);
				return xiaoqu ? xiaoqu.xiaoqu_name : '';
			},
			changeStatus(row) {
				smsTemplateSwitch(row.id).then((res) => {
					if (res.code == 200) {
						this.$message.success('状态修改成功');
						this.searchChange();
					} else {
						this.$message.error('状态修改失败');
					}
				});
			},
			// 重置
			reset() {
				this.form = {};
			},
			// 新增弹窗
			handleNewAdd() {
				this.title = "新增";
				this.reset();
				this.handleAdd();
				this.form.fee_count = 1;
				this.$nextTick(() => {
					this.$refs.form.clearValidate();
				});
			},
			// 修改弹窗
			handleClick(row) {
				this.title = "修改";
				this.form = JSON.parse(JSON.stringify(row));
				console.log('行修改点击：', this.form);
				if (this.form.xiaoqus && this.form.xiaoqus.length) {
					const stt = this.form.xiaoqus.split(",");
					this.form.xiaoqusArr = stt;
				}

				this.handleEdit();
			},
			// 点击确定
			submitForms() {
				if (this.form.xiaoqusArr && this.form.xiaoqusArr.length) {
					const stt = this.form.xiaoqusArr.join(',');
					this.form.xiaoqus = stt;
				}

				if (!this.form.fee_count || this.form.fee_count < 1) {
					this.$message.warning('请输入正确的计费条数');
					return;
				}

				try {
					// 提交表单
					this.submitForm(this.form);
				} catch (error) {
					// 处理提交失败的情况
					console.error("提交失败:", error);
					// 执行适当的操作，例如显示错误提示信息或进行其他处理
				}
			},
			// 关闭弹窗
			getout() {
				this.addOrEditOpen = false;
				this.$refs.form.clearValidate();
			},
		},
	};
</script>
<style scoped>
	/deep/.dialogHeight2 .el-dialog__body {
		overflow-y: auto;
	}

	/deep/.dialogHeight .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	/deep/.dialogHeightX .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	/deep/.el-table,
	.el-table th,
	.el-table td {
		border-radius: 10px;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
		font-size: 16px;
		font-family: Times, "Times New Roman";
		/* font-weight: 600; */
	}

	.topNav {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff;
		padding: 20px 20px;
		border-radius: 10px;
	}

	.navFormWrapper {
		display: flex;
		align-items: center;
	}

	.uploadSty .el-upload--picture-card {
		width: 110px;
		height: 110px;
		line-height: 110px;
	}

	/deep/.disUploadSty .el-upload--picture-card {
		display: none;
		/* 上传按钮隐藏 */
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409eff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 150px;
		height: 150px;
		line-height: 150px;
		text-align: center;
	}

	.avatar {
		width: 150px;
		height: 150px;
		display: block;
	}

	.avatar-wrapper {
		position: relative;
	}

	.el-icon-close {
		position: absolute;
		top: 0;
		right: 6vh;
		cursor: pointer;
	}

	.el-icon-close:hover {
		color: #409eff;
	}

	/deep/ .el-dialog__body {
		height: 60vh;
	}
</style>


// WEBPACK FOOTER //
// src/views/actAICallSms/yx_sms.vue